import { render, staticRenderFns } from "./VPagination.vue?vue&type=template&id=22317ab6"
import script from "./VPagination.vue?vue&type=script&lang=js"
export * from "./VPagination.vue?vue&type=script&lang=js"
import style0 from "./VPagination.vue?vue&type=style&index=0&id=22317ab6&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22317ab6')) {
      api.createRecord('22317ab6', component.options)
    } else {
      api.reload('22317ab6', component.options)
    }
    module.hot.accept("./VPagination.vue?vue&type=template&id=22317ab6", function () {
      api.rerender('22317ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/VPagination.vue"
export default component.exports